export enum Side {
  BOTTOM = 'bottom',
  TOP = 'top',
}

interface Entry {
  boundingClientRect: {
    x: number;
    y: number;
  };
}

/** Determine whether we are scrolling towards the top or the bottom. */
export const getIntersectionPosition = (entry: Entry) => {
  if (entry.boundingClientRect.y <= 0) {
    return Side.TOP;
  }
  return Side.BOTTOM;
};
